import * as React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import Logo from '../Logo/Logo'
import Comparator from '../Comparator/Comparator'

import { MultiSizeImage } from '../Comparator'

const MainComparatorContent = () => {
  return (
    <div className='content'>
        <Logo />
        <h1 className="title-main">Increasing image quality<br/> by machine learning
            <span className="title-sub">API ACCESS Starting at $99/month</span>
        </h1>

        <Link to="/apply" className="btn btn-with-text btn-with-gradient gradient-full btn-learn-more">
          Request Access
        </Link>
        <Link to="/demo" className="btn btn-with-text btn-with-gradient btn-learn-more btn-transparent-content">
          Check the Demo
        </Link>
    </div>
  )
} 
export default class ComparatorNavigation extends React.Component<{}> {
  render() {
    return (
      <div className=''>
        <StaticQuery
          query={query}
          render={data => {
            const getImageByKey = (key: string): MultiSizeImage => ({
                desktop: data[key].childImageSharp.fixed,
                tablet: data[key+'Tablet'].childImageSharp.fixed,
                mobile: data[key+'Mobile'].childImageSharp.fixed
            })

            return (
              <Comparator
                beforeLabel={null}
                afterLabel={null}
                darkened={true}
                content={MainComparatorContent()}
                beforeImage={getImageByKey('beforeImage1')}
                afterImage={getImageByKey('afterImage1')}
                active={false}
                demonstration={true}
                className='hide-on-mobile'
              />
            )
          }}
        />
      </div>
    )
  }
}

const query = graphql`
  query {
    beforeImage1: file(relativePath: { eq: "comparator/before-0.jpg" }) {
      childImageSharp {
        fixed(height: 714, width: 1440, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage1Tablet: file(relativePath: { eq: "comparator/before_tablet-0.jpg" }) {
      childImageSharp {
        fixed(height: 512, width: 768, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    beforeImage1Mobile: file(relativePath: { eq: "comparator/before_mob-0.jpg" }) {
      childImageSharp {
        fixed(height: 640, width: 414, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1: file(relativePath: { eq: "comparator/after-0.jpg" }) {
      childImageSharp {
        fixed(height: 714,  width: 1440, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1Tablet: file(relativePath: { eq: "comparator/after_tablet-0.jpg" }) {
      childImageSharp {
        fixed(height: 512, width: 768, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }

    afterImage1Mobile: file(relativePath: { eq: "comparator/after_mob-0.jpg" }) {
      childImageSharp {
        fixed(height: 640, width: 414, quality: 90) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`
